import { useEffect } from 'react'

export const useHtmlClass = ({ className }: { className: string }) => {
  useEffect(() => {
    document.querySelector('html')?.classList.add(className)

    return () => {
      document.querySelector('html')?.classList.remove(className)
    }
  }, [className])
}
